import { styled, StyledButton } from '@raskrask-dk/rr-components'

export const CustomerTypeButtons = styled('div', {
    display: 'grid',
    gap: 16,
    gridAutoFlow: 'column',

    '@desktop': {
        position: 'absolute',
        left: '50%',
        top: 8,
        transform: 'translateX(-50%)',
    },

    [`& ${StyledButton}`]: {
        minW: 125,
    },
})
